import { SquareAsterisk } from 'lucide-react'
import { GitHubLogo, GitLabLogo } from '@/logos'
import { AmazonWebServicesLogo } from '@/logos/aws'
import { DigitalOceanLogo } from '@/logos/digitalocean'
import { DockerLogo } from '@/logos/docker'
import { GoogleCloudLogo } from '@/logos/googlecloud'
import type { DockerRegistry } from '@/graphql.types'

export const registryMap: Record<
  DockerRegistry,
  { logo: typeof GitLabLogo | typeof SquareAsterisk; title: string }
> = {
  gitlab: {
    logo: GitLabLogo,
    title: 'GitLab Container Registry',
  },
  github: {
    logo: GitHubLogo,
    title: 'GitHub Container Registry',
  },
  dockerHub: {
    logo: DockerLogo,
    title: 'Docker Hub',
  },
  digitalOcean: {
    logo: DigitalOceanLogo,
    title: 'DigitalOcean Container Registry',
  },
  gcr: {
    logo: GoogleCloudLogo,
    title: 'Google Artifact Registry',
  },
  ecr: {
    logo: AmazonWebServicesLogo,
    title: 'Amazon ECR',
  },
  custom: {
    logo: SquareAsterisk,
    title: 'Custom Registry',
  },
}
